import { useEffect, useState } from 'react';

function useBottomInset(bottom: number = 0): number {
  const [bottomOffset, setBottomOffset] = useState(0);

  useEffect(() => {
    // SSR-safe: exit if window is not defined
    if (typeof window === 'undefined') {
      return;
    }

    const originalInnerHeight = window.innerHeight;

    const updateBottomPosition = () => {
      if (window.visualViewport) {
        // If visualViewport supported, calculates how much vertical space is taken up by the keyboard:
        const vv = window.visualViewport;
        const offset = window.innerHeight - (vv.height + vv.offsetTop);
        setBottomOffset(offset > 0 ? offset : 0);
      } else {
        // Fallback: check if keyboard reduced viewport height significantly
        const currentHeight = window.innerHeight;
        const keyboardHeight = originalInnerHeight - currentHeight;
        setBottomOffset(keyboardHeight > 100 ? keyboardHeight : 0); // 100px threshold
      }
    };

    updateBottomPosition();

    window.addEventListener('resize', updateBottomPosition);
    window.visualViewport?.addEventListener('resize', updateBottomPosition);
    window.visualViewport?.addEventListener('scroll', updateBottomPosition);

    return () => {
      window.removeEventListener('resize', updateBottomPosition);
      window.visualViewport?.removeEventListener('resize', updateBottomPosition);
      window.visualViewport?.removeEventListener('scroll', updateBottomPosition);
    };
  }, []);

  return bottomOffset || bottom;
}
export default useBottomInset;
